import { useEffect } from 'react'

/**
 * HOOK (Navegabilidade)
 * Recebe uma callback para o disparo de um filtro através do botão enter do teclado.
 */

export function useEnterKeySearch (callbackFilter: () =>void) {
    
    useEffect (() => {

        function keyListener(e:KeyboardEvent): void {
            if (e.key === 'Enter' && !e.defaultPrevented) {
                callbackFilter()
            }
        } 

        document.addEventListener('keydown', keyListener)

        return () => {
            document.removeEventListener('keydown', keyListener)
        }

    }, [callbackFilter])

}